/**
 * Ajax filtering for the Document Library
 */
(function (window, document, $, undefined) {
	'use strict';

	window.documentLibraryFilter = {

		/**
		 * Initialize script behavior.
		 *
		 * @since 1.0.0
		 */
		init: function () {
			documentLibraryFilter.initVars();
			documentLibraryFilter.getQueryVars();
			documentLibraryFilter.pageInit();
			documentLibraryFilter.bind();
			documentLibraryFilter.submit();
			documentLibraryFilter.createFiltersApplied();
			documentLibraryFilter.cloneRecordCount();
			documentLibraryFilter.tableSorting();
		},

		/**
		 * Setting and initializing all variables.
		 *
		 * @since 1.0.0
		 */
		initVars: function () {
			documentLibraryFilter.$base_url = $( "#base_url" ).val();
			documentLibraryFilter.$xhrQueue = [];
		},

		/**
		 * Get all of the select values for the query string
		 *
		 * @since 1.0.0
		 */
		getQueryVars: function () {
			// (re)set the object
			documentLibraryFilter.$query_vars = {};

			// Get non-checkbox values
			$( 'input.document-library-filter-input[type="text"], select.document-library-filter-input, input.document-library-filter-input[type="radio"]:checked' ).each(
				function () {
					// If a form field ins't empty add it to the array
					if ($( this ).val() !== '') {
						documentLibraryFilter.$query_vars[$( this ).data( 'arg-type' )] = $( this ).val();
					}
				}
			);

			// Special handling for tags checkboxes
			// Grab all the values and comma separate them
			documentLibraryFilter.$documentTypeValues = $( '.document-type-checkbox:checked' ).map(
				function () {
					return $( this ).val();
				}
			).get().join( "," );

			if (documentLibraryFilter.$documentTypeValues != '') {
				documentLibraryFilter.$query_vars['document_type'] = documentLibraryFilter.$documentTypeValues;
			}
		},

		/**
		 * Build the URL we need to call
		 *
		 * @since 1.0.0
		 */
		buildTheURL: function () {
			// Build the query string
			documentLibraryFilter.getQueryVars();

			// If empty use the base URL
			if ($.isEmptyObject( documentLibraryFilter.$query_vars )) {
				return documentLibraryFilter.$base_url;
			}

			var query_vars = '?';
			Object.keys( documentLibraryFilter.$query_vars ).forEach(
				function (key) {
					var value = documentLibraryFilter.$query_vars[key];
					if (value) {
						query_vars += key + '=' + value.replace( /\s/g, "+" ) + '&';
					}
				}
			);
			return documentLibraryFilter.$base_url + query_vars.replace( /&\s*$/, "" );
		},

		/**
		 * Put everything together and make the call
		 *
		 * @since 1.0.0
		 */
		makeTheCall: function (url) {
			// Kill all active xhr requests before starting a new one.
			var i = 0;
			while (documentLibraryFilter.xhrAbort()) {
				if (documentLibraryFilter.$xhrQueue[i] !== 'undefined') {
					documentLibraryFilter.$xhrQueue[i].abort();
				}
				i++;
			}
			// Make the call
			documentLibraryFilter.filterAjaxCall( url );
		},

		/**
		 * Call the formatted URL
		 *
		 * @since 1.0.0
		 */
		filterAjaxCall: function (url) {
			// Show the 'loading' overlay
			$( '.loading-overlay' ).show();

			// Make the call
			$( "#ajax-archive" ).load(
				url + ' #ajax-archive',
				function (response, status, xhr) {
					err = '';
					if (status == "success") {
						// Hide the overlay on success
						$( '.loading-overlay' ).hide();
						// Push the browser history state
						var stateObj   = {state: "ready"};
						var page_title = $( document ).find( "title" ).text();
						history.pushState( stateObj, page_title, url );
						// Update the record count
						documentLibraryFilter.cloneRecordCount();
						// Re-initialize sorting
						documentLibraryFilter.tableSorting();
					} else {
						if (typeof xhr.responseText != 'undefined') {
							var err = JSON.parse( xhr.responseText );
						}
					}
				}
			);
		},

		/**
		 * Abort all active xhr requests before making a new one.
		 *
		 * @since 1.0.0
		 */
		xhrAbort: function () {
			$( document ).ajaxSend(
				function (event, jqxhr, settings) {
					documentLibraryFilter.$xhrQueue.push( jqxhr ); //alert( settings.url );
				}
			);
			$( document ).ajaxComplete(
				function (event, jqxhr, settings) {
					var i;
					if ((i = $.inArray( jqxhr, documentLibraryFilter.$xhrQueue )) > -1) {
						documentLibraryFilter.$xhrQueue.splice( i, 1 ); //alert( "C:" + settings.url );
					}
				}
			);
			return documentLibraryFilter.$xhrQueue.length;
		},

		/**
		 * Add the "Filters Applied" options to the form
		 *
		 * @since 1.0.0
		 */
		createFiltersApplied: function () {

			// Build the query string
			documentLibraryFilter.getQueryVars();

			// If empty exit early
			if ($.isEmptyObject( documentLibraryFilter.$query_vars )) {
				return;
			}

			$( 'li.filter' ).remove();

			// Each over all selected filters
			Object.keys( documentLibraryFilter.$query_vars ).forEach(
				function (field_name) {
					var field_value = documentLibraryFilter.$query_vars[field_name];			
					// Explode the document_type tags into an array
					if ('document_type' === field_name) {
						var document_types = field_value.split( ',' );
						// Each over each separated tag (not as one one big CSV list)
						Object.keys( document_types ).forEach(
							function (doc_type_field_name) {
								var doc_type_field_value = document_types[doc_type_field_name];
								// Append each tag separately
								if ($( 'li[data-filter-value="' + doc_type_field_value + '"]' ).length === 0) {
									$( '#active-filters' ).append(
										'<li class="filter" data-filter-value="' + doc_type_field_value + '">' +
										'<span class="label">' + $( ':checkbox[value="' + doc_type_field_value + '"]' ).prop( 'checked', 'true' ).data( 'value-translated' ) + '</span>' +
										'<span class="close"><i class="jh-icon-No"></i></span>' +
										'</li>'
									);
								}
							}
						);
					}
					// All other fields
					else {
						if (field_value && $( 'li[data-filter-value="' + field_value + '"]' ).length === 0 ) {
							// For selects we need the option value
							if ($( '*[value="' + field_value + '"]' ).is( "option" )) {
								var filter_value = $( '*[value="' + field_value + '"]' ).text();
							} else {
								var filter_value = $( 'input[value="' + field_value + '"]' ).prop( 'checked', 'true' ).data( 'value-translated' );
							}
							$( '#active-filters' ).append(
								'<li class="filter" data-filter-value="' + field_value + '">' +
								'<span class="label">' + filter_value + '</span>' +
								'<span class="close"><i class="jh-icon-No"></i></span>' +
								'</li>'
							);
						}
					}
				}
			);
		},

		/**
		 * Remove the "Filters Applied" options to the form
		 *
		 * @since 1.0.0
		 */
		removeFiltersApplied: function ( inputValue ) {

			// Remove the "Applied Filter" list item
			$( 'li[data-filter-value="' + inputValue + '"]' ).remove();

			// Reset the form input based on its type
			// Input text fields
			$( 'input[type="text"][value="' + inputValue + '"]' ).val( '' );

			//Uncheck jh-checkboxes and radio buttons
			$( '*[value="' + inputValue + '"]' ).parent().removeClass( 'jh-checkbox--checked' );
			$( '*[value="' + inputValue + '"]' ).prop( "checked", false );

			// Manually set the select2.js fields to empty and reset them
			if ( ! isNaN( inputValue )) {
				$( '#filter_product' ).val( null ).trigger( 'change' );
			}
		},

		/**
		 * Update the products dropdown based on the selected vehicle
		 *
		 * @since 1.0.0
		 */
		filterProductsByVehicle: function (productVehicle) {
			// Have to do this kind of backwards to support the Bootstrap Nice Select
			// Hide all options
			$( '#filter_product option' ).attr( 'disabled', 'disabled' ).hide();
			// Add back the options that match the selected vehicle
			$( '#filter_product option[data-product-vehicle=' + productVehicle + ']' ).removeAttr( 'disabled' ).show();
			// Manually refresh bootstrap selectpicker
			$( '#filter_product' ).selectpicker( 'refresh' );
		},

		/**
		 * Clone the "x of y" record count from the AJAX response to the hero
		 *
		 * @since 1.0.0
		 */
		cloneRecordCount: function () {
			var recordCount = $( '#static-record-count' ).html();
			$( '#dynamic-record-count' ).html( recordCount );
		},

		/**
		 * Bind all event listeners.
		 *
		 * @since 1.0.0
		 */
		bind: function () {

			// On any form state change make the AJAX query
			$( ".document-library-filter-input, .document-type-checkbox" ).bind(
				// Debounce for 1 second before triggering
				"keyup change",
				jh_custom.debounce( 
					function() {
				  		documentLibraryFilter.makeTheCall( documentLibraryFilter.buildTheURL() ),
				  		documentLibraryFilter.createFiltersApplied(),
						1500
					}
				)
			);

			// Remove selected filter and rerun the AJAX query
			$( 'body' ).on(
				'click',
				'.filter span.close',
				function (e) {
					e.preventDefault();
					documentLibraryFilter.removeFiltersApplied( $( this ).parent().data( 'filter-value' ) );
					documentLibraryFilter.makeTheCall( documentLibraryFilter.buildTheURL() );
				}
			);

			// Hide all products that are not the matched vehicle
			$( 'input[type="radio"][name="document_vehicle"]' ).bind(
				// Debounce for 1 second before triggering
				'change',
				function (e) {
					documentLibraryFilter.filterProductsByVehicle( $( this ).val() );
				}
			);

		},

		/**
		 * Submit Button.
		 *
		 * @since 1.0.0
		 */
		submit: function () {
			$( "#document-library-filter" ).submit(
				function (e) {
					e.preventDefault();
					documentLibraryFilter.makeTheCall( documentLibraryFilter.buildTheURL() );
				}
			);

		},

		/**
		 * Table sorting.
		 *
		 * @since 1.0.0
		 */
		tableSorting: function () {
			if ( $( 'body' ).find( "#document-library-results" ).length ) {
				new Tablesort(
					document.getElementById( 'document-library-results' )
				);
			}
		},

		/**
		 *  Adjust the filter on initial page load if coming from another link and not ajax
		 *
		 * @since 1.0.0
		 */
		pageInit: function () {

			// If there are any query vars at all, scroll down to the results
			if ($.isEmptyObject( documentLibraryFilter.$query_vars )) {
				// No empty actions at this time
			} else {
				// Add the checkbox class to pre-selected items
				if (documentLibraryFilter.$query_vars['document_type']) {
					// Each over each separated tag (not as one one big CSV list)
					var document_types = documentLibraryFilter.$query_vars['document_type'].split( ',' );
					
					Object.keys( document_types ).forEach(
						function (doc_type_field_name) {
							var doc_type_field_value = document_types[doc_type_field_name];
							$( '*[value="' + doc_type_field_value + '"]' ).parent().addClass( 'jh-checkbox--checked' );
						}
					);
				}
			}
		},

	};

	documentLibraryFilter.init();

})( window, document, jQuery );
